import {Component, Inject, Injectable, Input} from '@angular/core';
import {ContentResponse} from "../interface/contentResponse";
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {AddUserCardContentComponent} from "../add-user-card-content/add-user-card-content.component";
import {UserContentComponent} from "../user-content/user-content.component";
import {ContentType} from "../interface/contentType";
import {ContentService} from "../service/content.service";
import {BehaviorSubject} from "rxjs";

@Injectable()
export class UserCardContentListService {
  public static dialogRefSubject = new BehaviorSubject<MatDialogRef<AddUserCardContentComponent> | null>(null);
}
